<template>
  <form>
    <TheInput
      type="datepicker"
      :dark="true"
      label="ГТП"
      placeholder="Дата за следващ преглед"
      v-model="inventory.serviceInfo.gtp"
      @update:modelValue="setFieldValue($event, 'gtp')"
    />
    <TheInput
      type="datepicker"
      :dark="true"
      label="ВИНЕТКА"
      placeholder="валидна до дата"
      v-model="inventory.serviceInfo.vinetka"
      @update:modelValue="setFieldValue($event, 'vinetka')"
    />
    <TheInput
      type="datepicker"
      :dark="true"
      label="КАСКО"
      placeholder="валидна до дата"
      v-model="inventory.serviceInfo.kasko"
      @update:modelValue="setFieldValue($event, 'kasko')"
    />
    <TheInput
      type="datepicker"
      :dark="true"
      label="ГРАЖДАНСКА ОТГОВОРНОСТ"
      placeholder="валидна до дата"
      v-model="inventory.serviceInfo.grajdanska"
      @update:modelValue="setFieldValue($event, 'grajdanska')"
    />
    <TheInput
      type="datepicker"
      :dark="true"
      label="ЛИЗИНГ ВНОСКА"
      placeholder="следваща вноска дата"
      v-model="inventory.serviceInfo.lizing"
      @update:modelValue="setFieldValue($event, 'lizing')"
    />

    <p class="blue">ОБСЛУЖВАНИЯ ПО АВТОМОБИЛА-ПРАЩА СЕ МЕЙЛ ПРИ</p>
    <section class="services-wrapper" v-if="inventory.services">
      <div
        class="service"
        v-for="(service, index) of inventory.services"
        :key="`inv-service-${index}`"
      >
        <div class="row">
          <TheInput
            :dark="true"
            :label="`${service.name.toUpperCase()} ПРИ ДОСТИГАНЕ НА`"
            placeholder="Въведете стойност"
            v-model="service.limit"
            />
            <!-- @input="delete service.notified" -->
          <span @click="editService(service)" class="mck mck--edit">c</span>
          <span @click="removeService(index)" class="mck mck--delete">b</span>
        </div>
        <div class="row">
          <TheInput
            type="dropdown"
            :options="serviceTypes"
            :dark="true"
            prop="name"
            propValue="value"
            label="Вид"
            placeholder="Избери км/мч"
            :value="service.type"
            @update:modelValue="service.type = $event.value"
          />
        </div>
      </div>
    </section>

    <div @click="addService()" class="add">
      <span class="mck">L</span>
      <p>
        {{
          `Добавете ${
            !inventory.services || !inventory.services.length ? "" : "друго"
          } обслужване`
        }}
      </p>
    </div>

    <transition name="fade">
      <EditInputModal
        v-if="inputForEdit"
        :inputForEdit="inputForEdit"
        :isComingFromCompany="true"
        placeholder="Добавете нов вид обслужване"
        customWarning="Име"
        @save="setServiceName"
        @close="closeEditInputModal"
      />
    </transition>
  </form>
</template>

<script>
import TheInput from "@/components/TheInput.vue";
import EditInputModal from "@/components/shared/EditInputModal.vue";
export default {
  props: ["inventory", "type"],
  components: { TheInput, EditInputModal },
  data() {
    return {
      inputForEdit: "",
      serviceTypes: [
        { name: "километри", value: "km" },
        { name: "моточасове", value: "mh" },
      ],
    };
  },
  methods: {
    setFieldValue(value, field) {
      this.$set(this.inventory.serviceInfo, field, "");
      this.$set(this.inventory.serviceInfo, field, value);
    },
    setServiceName(e) {
      this.inventory.services[e.where].name = e.value;
      this.inputForEdit = "";
    },
    editService(service) {
      const index = this.inventory.services.indexOf(service);
      this.inputForEdit = {
        value: service.name,
        where: index,
      };
    },
    removeService(serviceIndex) {
      this.inventory.services.splice(serviceIndex, 1);
    },
    closeEditInputModal() {
      // if user cancels the creation of the new service, remove it
      if (!this.inputForEdit.value) {
        this.inventory.services.splice(this.inventory.services.length - 1, 1);
      }
      this.inputForEdit = "";
    },
    addService() {
      if (!this.inventory.services) this.$set(this.inventory, "services", []);
      const newService = { date: new Date(), name: "", limit: "", type: "" };

      this.inventory.services.push(newService);

      this.inputForEdit = {
        value: newService.name,
        where: this.inventory.services.length - 1,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.blue {
  color: #1964ba;
  font-size: 12px;
  font-weight: bold;
  margin: 10px 0;
}
.services-wrapper {
  max-height: 200px;
  overflow: auto;

  .service {
    display: flex;
    gap: 10px;
    justify-content: space-between;

    .row {
      &:first-of-type {
        position: relative;
        flex: 1;
      }

      .mck {
        cursor: pointer;
        font-size: 16px;
        position: absolute;
        right: 30px;
        bottom: 10px;
        transition: 0.3s all;

        &:hover {
          opacity: 0.5;
        }

        &:last-of-type {
          right: 5px;
        }
      }
    }
  }
}
.add {
  margin-top: 5px;
}
</style>
